import GLightbox from "glightbox";
import initVoices from "./voices.js";

document.addEventListener("DOMContentLoaded", function (event) {

    // INIT LIGHTBOX (Galerie)
    const lightbox = GLightbox({
        selector: '[data-gallery="gallery"]',
        touchNavigation: true,
        loop: true,
    });

    // INIT VIDEO-LIGHTBOX (Hero-Kachel, erkennt YouTube/Vimeo-URLs automatisch)
    const videoLightbox = GLightbox({
        selector: '.js-video',
        touchNavigation: true,
    });

    // INIT VOICE-PLAYER
    initVoices();
});
